import React, { useEffect, useState } from 'react';
import { Table, Badge, Spinner, Alert } from 'react-bootstrap';
import { formatCurrency } from '../../utility';
import apiService from '../../services/apiServices';
import moment from 'moment';
import BrandTable from '../core/components/BrandTable/BrandTable';
import { FaHistory, FaUser } from 'react-icons/fa';

const StockSalesHistory = ({ itemId, variantId }) => {
    const [loading, setLoading] = useState(false);
    const [sales, setSales] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchSalesHistory();
    }, [itemId, variantId]);

    const fetchSalesHistory = async () => {
        try {
            setLoading(true);
            const res = await apiService.get(`/stock/items/${itemId}/sales-history`, {
                params: { variantId }
            });
            setSales(res.data.sales || []);
        } catch (err) {
            console.error("Failed to load sales history", err);
            setError("Could not load sales history.");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            key: 'invoice_id',
            label: 'Invoice',
            render: (val) => <span className="fw-bold text-primary">{val}</span>
        },
        {
            key: 'invoice_date',
            label: 'Date',
            render: (val) => moment(val).format('LLL')
        },
        {
            key: 'customer_name',
            label: 'Customer',
            render: (val) => (
                <div className="d-flex align-items-center gap-2">
                    <FaUser size={12} className="text-muted" />
                    <span>{val || "Walk-in"}</span>
                </div>
            )
        },
        {
            key: 'batch_number',
            label: 'Batch/Serial',
            render: (val, row) => (
                <div>
                    {row.isSerialized ? (
                        <div className="d-flex flex-wrap gap-1">
                            {row.serialNumbers?.map(s => (
                                <Badge key={s} bg="info" className="font-monospace">{s}</Badge>
                            ))}
                        </div>
                    ) : (
                        <Badge bg="secondary" className="font-monospace">{val}</Badge>
                    )}
                </div>
            )
        },
        {
            key: 'quantity',
            label: 'Qty',
            align: 'center',
            render: (val) => <Badge bg="dark">{val}</Badge>
        },
        {
            key: 'price',
            label: 'Unit Price',
            align: 'right',
            render: (val) => formatCurrency(val)
        },
        {
            key: 'totalPrice',
            label: 'Subtotal',
            align: 'right',
            render: (val) => <span className="fw-bold">{formatCurrency(val)}</span>
        }
    ];

    if (loading) return <div className="text-center py-4"><Spinner animation="border" size="sm" variant="primary" /></div>;
    if (error) return <Alert variant="danger">{error}</Alert>;

    return (
        <BrandTable
            data={sales}
            columns={columns}
            emptyMessage="No sales history found for this item."
            icon={<FaHistory />}
            title="Recent Sales History"
            searchable={true}
            striped={true}
            bordered={true}
            hover={true}
            size="sm"
        />
    );
};

export default StockSalesHistory;
